import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { HttpModule } from '@angular/http';
import { FormsModule,  ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { HeaderComponent } from './include/header/header.component';
import { FooterComponent } from './include/footer/footer.component';
import { LeftComponent } from './include/left/left.component';
import { AppRoutingModule } from './app.routes';
import { RootComponent } from './root.component';

import { PosterModule } from './poster/poster.module';
import { UserModule } from './user/user.module';
import { ClientModule } from './client/client.module';
import { CommonModule } from './common/common.module';
import { OauthCheck } from './common/oauth.check';
import { JwtService } from './jwt/jwt.service';
import { OAuthService } from 'angular-oauth2-oidc';

import { SignModule } from './sign/sign.module';

import { COMPOSITION_BUFFER_MODE } from '@angular/forms';

import { ImageHostingModule } from './images/image-hosting.module';
import { RoulletComponent } from './roullet/roullet.component';
import { HttpInterceptor } from './common/interceptor/http-interceptor';
import { ImageHostingService } from './common/api/image-hosting.service';
import { ExtraService } from './common/api/extra.service';
import { AuthGuard } from './common/guard/auth.guard';
import { MoveCheck } from './common/guard/move.check';
import { UserService } from './common/api/user.service';
import { LoginGuard } from './common/guard/login.guard';

@NgModule({
    declarations: [ AppComponent, HeaderComponent,  RootComponent, LeftComponent,
       FooterComponent, RoulletComponent],
    imports : [ BrowserModule, AppRoutingModule, FormsModule, HttpModule, PosterModule,
      UserModule,  ReactiveFormsModule, SignModule, ImageHostingModule, ClientModule,
      CommonModule,
    ],
    bootstrap : [ AppComponent ],
    providers : [ AuthGuard, MoveCheck, OauthCheck, LoginGuard,
       JwtService, OAuthService,
       HttpInterceptor,
       ImageHostingService,
       ExtraService,
       UserService,
    {
      provide : COMPOSITION_BUFFER_MODE,
      useValue: false
    } ],

})
export class AppModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/app.module.ts